import React, { useId } from "react";
import styled from "styled-components";

import { calculatorTypeToTI, TICalculatorType } from "../utils/calculator";
import Draggable from "../utils/Draggable";

const StyledIframe = styled.iframe`
  border: none;
`;

const TI_VERSION = "2.11.0.133";

type CalculatorSize = {
  width: number;
  height: number;
};
const sizes: Record<TICalculatorType, CalculatorSize> = {
  ti108: { width: 230, height: 330 },
  ti30mv: { width: 270, height: 510 },
  ti84p: { width: 270, height: 600 },
};

type CalculatorProps = {
  type: "BASIC" | "SCIENTIFIC" | "GRAPHING" | undefined;
};
const Calculator = ({ type }: CalculatorProps) => {
  const id = useId();

  if (!type) {
    return null;
  }

  const tiType = calculatorTypeToTI[type];

  if (!process.env.REACT_APP_VENDOR_RESOURCES) {
    console.error("Missing Vendor Resources Env Var");
    return <CalculatorNonIdealState />;
  }

  return (
    <Draggable>
      <StyledIframe
        title={id}
        width={sizes[tiType].width}
        height={sizes[tiType].height}
        src={`${process.env.REACT_APP_VENDOR_RESOURCES}/ti/${TI_VERSION}/${tiType}.html`}
      />
    </Draggable>
  );
};

const CalculatorNonIdealState = () => {
  return (
    <div>
      <h2>Calculator Not Available</h2>
      <p>The requested calculator is not available at this time.</p>
    </div>
  );
};

export default Calculator;
